module.exports = __webpack_public_path__ + "img/6.66567460.png";